import * as React from "react";
import { getFreeDeliveryThreshold } from "../model";

import { useMyBagPresentationModel } from "../providers";

export const MyBagFreeShippingCalculator: React.FunctionComponent = () => {
  const { presentationMyBagOrder } = useMyBagPresentationModel();

  const freeDeliveryThreshold = getFreeDeliveryThreshold();

  const value = React.useMemo(() => {
    if (!presentationMyBagOrder) {
      return 0;
    }

    const value =
      presentationMyBagOrder.orderValueByItemsBreakdown
        .orderTotal_withoutDiscountsOrAnything -
      presentationMyBagOrder.orderValueByItemsBreakdown
        .memberDiscountsAppliedOnTheOrderTotal -
      presentationMyBagOrder.orderValueByItemsBreakdown
        .saleDiscountsAppliedOnTheOrderTotal -
      presentationMyBagOrder.orderValueByItemsBreakdown.allThePromotionalDiscounts.reduce(
        (acc, thisDiscount) => acc + (thisDiscount.value || 0),
        0
      );

    return value;
  }, [presentationMyBagOrder]);

  const percentageTowardsFreeShipping = React.useMemo(() => {
    let percentageTowardsFreeShipping = 0;
    const one_hundred_percent = 1;
    if (value <= freeDeliveryThreshold) {
      percentageTowardsFreeShipping =
        (value / freeDeliveryThreshold) * one_hundred_percent;
    } else {
      percentageTowardsFreeShipping = one_hundred_percent;
    }
    return percentageTowardsFreeShipping;
  }, [value, freeDeliveryThreshold]);

  const moneyLeftToFreeShipping = React.useMemo(() => {
    let moneyLeftToFreeShipping = 0;
    if (value <= freeDeliveryThreshold) {
      moneyLeftToFreeShipping = freeDeliveryThreshold - value;
    }
    return moneyLeftToFreeShipping;
  }, [value, freeDeliveryThreshold]);

  const progressBar = React.useMemo(() => {
    return (
      <React.Fragment>
        <div className="progress-bar">
          <div
            className="value"
            style={{
              width: `${percentageTowardsFreeShipping * 100}%`,
            }}
          ></div>
        </div>
      </React.Fragment>
    );
  }, [percentageTowardsFreeShipping]);

  const achievementLabel = React.useMemo(() => {
    return (
      <React.Fragment>
        {percentageTowardsFreeShipping < 1 ? (
          <p className="achievement locked">
            <span>{`You are \$`}</span>
            <span>{`${moneyLeftToFreeShipping.toFixed(2)}`}</span>
            <span>{` away from free shipping`}</span>
          </p>
        ) : (
          <p className="achievement unlocked">
            <span>{`You have qualified for free shipping`}</span>
          </p>
        )}
      </React.Fragment>
    );
  }, [percentageTowardsFreeShipping, moneyLeftToFreeShipping]);

  if (!presentationMyBagOrder) {
    return null;
  }

  return (
    <section className="my-bag-free-shipping-calculator">
      <p className="title">{`Free shipping calculator`}</p>
      <div className="progress-bar-container">{progressBar}</div>
      {achievementLabel}
    </section>
  );
};
